export class RelatedLicense {
  constructor(
    public product: string,
    public numberOfSeats: number,
    public expiration?: Date,
    public nextExpiringPointCreditDate?: Date,
  ) {
  }
}
